import { useContext } from "react"
import { UserContext } from "@contexts/UserContext";
import { replacePlaceholder } from "@components/Filters/FilterForm/FilterUtils";

const useDataPlaceholder = () => {
    //This hook manage the default placeholder replacement, it returns the funcion to use for replacement.
    const { currentUser } = useContext(UserContext)
    const replace = (value) => {
        return replacePlaceholder(value, currentUser.UserID)
    }
    return replace
}

export default useDataPlaceholder
